import { getAriConfig, toAri } from '@atlassian/jira-platform-ari';

export const getResourceId = (ariLikeString: string): string => {
	const ari = toAri(ariLikeString);
	if (ari === undefined) {
		throw Error('Invalid ARI');
	}
	return getAriConfig(ari).resourceId;
};
